<template lang="pug">
.sidebar-accessory-product
  loading(v-if="isLoading")
  .sidebar-product-load(v-else)
    MediaImages.media(layout="force-mobile" :gallery="product.gallery" :modelValue="activeImg")
    h5 {{__('PRODUCT')}}
    | {{product.name}}
    .badge-holder
      product-badges(:buy-request="buyRequest")
    .line
    .description
      h5 {{__('DESCRIPTION')}}
      RenderBlock.description-contents.view-all(:block="descriptionTab?.slots.default" :product="product")
</template>
<script lang="ts" setup>
import { onMounted, computed, ref } from 'vue'
import ProductBadges from '../../components/rhpa/badges.vue'
import { createBuyRequest } from '@/js/helpers/buy-request'
import { useProductStore } from '@/js/stores/productStore'
import { useRogue } from '@/js/services/Rogue'

const props = defineProps({
  productId: {
    type     : Number,
    required : true,
  },
  auProductId: {
    type     : Number,
    required : false,
  },
  euProductId: {
    type     : Number,
    required : false,
  },
})

const productStore = useProductStore()
const rogue = useRogue()

const buyRequest = ref({})
const activeImg  = ref(0)

const products = computed(() => productStore.products)

const activeProductId = computed(() => {
  if (rogue.site.code === 'AUS' && props.auProductId) {
    return props.auProductId
  }
  if (['EUR', 'GBR'].includes(rogue.site.code) && props.euProductId) {
    return props.euProductId
  }

  return props.productId
})

const product = computed(() => products.value[activeProductId.value])

const isLoading = computed(() => !product.value)

const descriptionTab = computed(() => {
  try {
    return product.value?.roguebuilder?.slots.tabs?.[0]?.slots.default[0]
  } catch (e) {
    return null
  }
})

async function load() {
  await productStore.load(activeProductId.value, rogue)
  buyRequest.value = createBuyRequest(product.value, rogue)
}

onMounted(() => {
  load()
})
</script>
<style lang="scss">
.sidebar-product {
  .product-stars-container {
    pointer-events: none;
  }

  .write-review {
    display: none;
  }

  .product-tab > .row > .column {
    width: 100%
  }
}

</style>

<style lang="scss" scoped>
.description {
  margin: $space-s 0;

  h6 {
    color: $color-black-light;
    font-size: $size-xs;
  }
}

.sidebar-accessory-product {
  h5 {
    font-family: $font-condensed;
    font-size: 14px;
  }
}

.sidebar-rhpa {
  border-bottom: $border-width-thin solid $color-gray;
}

.view-more {
  margin-top: $space-s;
}

.view-details:hover {
  border-width: 1px;
}

.description-contents {
  max-height: 144px;
  overflow: hidden;

  &:not(.view-all) {
    -moz-box-shadow: inset 0 -10px 10px -10px #ffffff;
    -webkit-box-shadow: inset 0 -10px 10px -10px #ffffff;
    box-shadow: inset 0 -10px 10px -10px #ffffff;
  }

  &.view-all {
    max-height: inherit;
  }

  &:deep() {
    > span > h2:first-child {
      display: none;
    }
  }
}

.media {
  margin-bottom: $space-s;
}

.line {
  background-color: $color-gray;
  margin: $space-m 0;
  height: 1px;
  width: 100%;
}

.see-more {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: $weight-bold;
  color: $color-black-light;
  font-size: $size-xs;
  margin: $space-s 0;

  .icon {
    margin-left: $space-xxs;
    width: $size-xxs;
  }
}

.badge-holder {
  margin-top: $space-s;
}

.view-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid $color-gray;
  padding: $space-s;
  width: 100%;
  color: $color-black-light;
  text-decoration: none;
  font-family: $font-condensed;
  font-weight: $weight-bold;
  font-size: $size-s;

  .icon {
    width: $size-xs;
    height: $size-xs;
  }
}
</style>
